module.exports = __webpack_public_path__ + "081db8384af2dfc67527d07dc4a4d8bf.pdf";